import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TourDetail from "../pages/tourDetail/page";
import AboutPage from "../pages/about/page";
import WhyUsPage from "../pages/whyUs/page";
import SpecialServicesPage from "../pages/specialServices/page";
import ToursPage from "../pages/tours/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import ProfilePage from "../pages/profile/page";
import BookingPage from "../pages/booking/page";
import AdminPage from "../pages/admin/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blogDetail/page";
import ExperienceDetail from "../pages/experience/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tours",
    element: <ToursPage />,
  },
  {
    path: "/tour/:id",
    element: <TourDetail />,
  },
  {
    path: "/experience/:id",
    element: <ExperienceDetail />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/why-us",
    element: <WhyUsPage />,
  },
  {
    path: "/special-services",
    element: <SpecialServicesPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/booking/:tourId",
    element: <BookingPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;